// extracted by mini-css-extract-plugin
export default {"addBtn":"LessonsTab_addBtn__Vb3dd"};